import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const GetSubscriptionTermsConditions = graphql(`
  query GetSubscriptionTermsConditions($sku: String!, $tenantId: ID!) {
    product {
      getVariants(skus: [$sku], tenantId: $tenantId, language: "no-nb") {
        sku
        product {
          shape {
            identifier
          }
        }
        components(identifiers: ["vilkar"]) {
          componentId
          content {
            ... on RichTextContent {
              html
            }
          }
        }
      }
    }
  }
`);
